import { Popconfirm, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

import { Lightbox } from "../../../../modal_image";
import { CrossIcon } from "../../../../resource/icons";
import useAllowChanges from "../../hooks/useAllowChanges";

import "./picture.scss";

let isLightboxOpened = false;

const Picture = ({ previewURL, name, onDelete, getFile }) => {
	const [showLightBox, setShowLightbox] = useState(false);
	const [showConfirm, setShowConfirm] = useState();
	const [fullPicture, setFullPicture] = useState();
	const [loading, setLoading] = useState(false);
	const isMounted = useRef();
	const changeable = useAllowChanges();
	useEffect(() => {
		isMounted.current = true;
		return () => {
			isMounted.current = false;
			isLightboxOpened = false;
		};
	}, []);
	useEffect(() => {
		if (changeable) {
			const listener = () => {
				setShowConfirm(false);
			};
			document
				.getElementsByClassName("NewVoting")[0]
				.addEventListener("scroll", listener);
			document.body.addEventListener("click", listener);
			return () => {
				document
					.getElementsByClassName("NewVoting")[0]
					.removeEventListener("scroll", listener);
				document.body.removeEventListener("click", listener);
			};
		}
	}, [changeable]);

	if (!previewURL) {
		return null;
	}

	return (
		<div className="picture-preview_container">
			<Spin spinning={loading}>
				<img
					src={previewURL}
					alt={name}
					className="picture-preview"
					onClick={async () => {
						setLoading(true);
						try {
							let file = await getFile();
							if (isMounted) {
								if (!isLightboxOpened) {
									setShowLightbox(name);
									setFullPicture(file);
									isLightboxOpened = true;
								}
							}
						} catch (e) {
							if (axios.isCancel(e)) {
								isLightboxOpened = false;
							}
						}

						setLoading(false);
					}}
				/>
			</Spin>
			{showLightBox && (
				<Lightbox
					medium={fullPicture}
					large={fullPicture}
					alt={name}
					loading={loading}
					showRotate={true}
					onClose={() => {
						setShowLightbox(false);
						isLightboxOpened = false;
					}}
				/>
			)}
			{changeable && (
				<Popconfirm
					visible={showConfirm}
					placement="top"
					title={"Удалить файл?"}
					onConfirm={() => {
						onDelete();
						setShowConfirm(false);
					}}
					onCancel={() => {
						setShowConfirm(false);
					}}
					okText="Да"
					cancelText="Нет"
				>
					<CrossIcon
						className="cross-icon"
						onClick={() => setShowConfirm(true)}
					/>
				</Popconfirm>
			)}
		</div>
	);
};

export default Picture;
